import {Button, Typography} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";
import {STYLES} from "./STYLES";
import {ViewModelProps} from "../../../../config/type";

interface SubjectButtonUIProps {
  onClick: (id: string) => void;
  subjectItem: {
    id: string;
    viewModel: ViewModelProps;
  };
  isSelected: boolean;
}
export default function SubjectButtonUI({
  onClick,
  subjectItem,
  isSelected,
}: SubjectButtonUIProps) {
  return (
    <Button
      key={subjectItem.id}
      variant="contained"
      onClick={() => onClick(subjectItem.id)}
      startIcon={
        <MaterialSymbol
          icon={subjectItem.viewModel.icon ?? "title"}
          weight={300}
          fill={isSelected}
          style={{
            fontSize: "1.5rem",
            marginBottom: "12px",
          }}
        />
      }
      sx={{
        ...STYLES.subjectPopperButton,
        borderColor: isSelected ? subjectItem.viewModel.color?.main : "",
        color: isSelected
          ? subjectItem.viewModel.color?.main
          : "secondary.contrastText",
        bgcolor: isSelected
          ? subjectItem.viewModel.color?.light
          : "secondary.light",
      }}>
      <Typography sx={STYLES.subjectPopperButtonTypography}>
        {subjectItem.viewModel.name}
      </Typography>
    </Button>
  );
}
